import type { ApiChild, Child } from '../types';
import { toChildBase } from './child-base.api';

export const toChildListItem = (api: ApiChild, now: number = Date.now()): Child => ({
  ...toChildBase(api, now),
  development: { observations: [] },
  notes: [],
  observations: [],
});
